(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[397],{

/***/ 9763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes",
      function () {
        return __webpack_require__(3694);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _components_layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2930);
/* harmony import */ var _components_PageSeo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8144);



var MotesPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageSeo__WEBPACK_IMPORTED_MODULE_2__/* .NotesPageSeo */ .vG, {});
};
MotesPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts__WEBPACK_IMPORTED_MODULE_1__/* .NoteSectionLayout */ .x, {
        initialData: page.props.data,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (MotesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [133,655,774,888,179], function() { return __webpack_exec__(9763); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);